module.exports = __webpack_public_path__ + "static/media/auditorium_entrance.722a0856.png";